export function initAccordion() {
  $(document).on('click', '.accordion__header', function() {
    $(this).toggleClass('active');
    $(this).siblings('.accordion__content')?.slideToggle(200);
    $(this).find('.accordion__icon')?.toggleClass('active');
  })
}